import { fetchProviders } from '@/pages/parametrizacion/providers/Services/providers.services';

export const consumablesColumns = [
  { id: 'nombre', label: 'Nombre', type: 'text', sortable: true, required: true },
  { id: 'descripcion', label: 'Descripción', type: 'textarea', sortable: false, required: false },

  {
    id: 'tipo',
    label: 'Tipo',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'Limpieza', label: 'Limpieza' },
      { value: 'Amenities', label: 'Amenities' },
      { value: 'Mantenimiento', label: 'Mantenimiento' },
      { value: 'Cocina', label: 'Cocina' },
      { value: 'Baño', label: 'Baño' },
      { value: 'Oficina', label: 'Oficina' },
      { value: 'Otro', label: 'Otro' },
    ],
  },
  {
    id: 'proveedor',
    label: 'Proveedor',
    type: 'select',
    sortable: true,
    required: false,
    asyncData: async () => {
      try {
        const response = await fetchProviders({ limit: 1000, offset: 1, query: { estado: 'Activo' } });
        return response.data.map(provider => ({
          value: provider._id,
          label: provider.nombre,
          data: { id: provider._id, nombre: provider.nombre }
        }));
      } catch (error) {
        console.error('Error loading providers:', error);
        return [];
      }
    },
    displayValue: (value) => value?.nombre || 'Sin proveedor',
    accessorKey: 'proveedor.nombre',
  },
  {
    id: 'precio',
    label: 'Precio',
    type: 'number',
    sortable: true,
    required: false,
    placeholder: 'Precio del insumo',
    displayValue: (value) => value ? `$${Number(value).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}` : '-',
  },
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
  },
];

export const columnsExcel = {
  nombre: 'Nombre',
  descripcion: 'Descripción',
  'proveedor.nombre': 'Proveedor',
  tipo: 'Tipo',
  estado: 'Estado',
  createdAt: 'Fecha de Creación',
  updatedAt: 'Fecha de Actualización',
};
